<!--
 * @Description: 骨架屏，loading作用
 * @Version: 2.0
 * @Date: 2021-09-27 14:21:28
 * @LastEditTime: 2021-10-18 14:21:28
-->
<template>
    <div class="skeleton-screen">
        <template v-if="searchType === 'all'">
            <div v-for="item in 2" :key="item" class="main">
                <div class="top">
                    <div class="top-content animation" />
                </div>
                <div v-for="res in 3" :key="res" class="bottom">
                    <div class="bottom-contents">
                        <div class="checkbox animation" />
                        <div class="circle animation" />
                        <div class="content">
                            <div
                                :class="[
                                    searchType === 'chat'
                                        ? 'content-top'
                                        : 'content-bottom',
                                    'animation'
                                ]"
                            />
                            <div
                                :class="[
                                    searchType === 'chat'
                                        ? 'content-bottom'
                                        : 'content-top',
                                    'animation'
                                ]"
                            />
                        </div>
                    </div>
                </div>
                <div class="division">
                    <div class="line" />
                </div>
            </div>
        </template>
        <template
            v-else-if="searchType === 'contact' || searchType === 'group'"
        >
            <div v-for="item in 8" :key="item" class="bottom">
                <div class="bottom-contents">
                    <div class="checkbox animation" />
                    <div class="circle animation" />
                    <div class="content">
                        <div class="content-top animation" />
                        <div class="content-bottom animation" />
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        searchType: {
            type: String,
            default: 'contact'
        }
    },
    data() {
        return {}
    }
}
</script>
<style lang="scss" scoped>
.skeleton-screen {
    height: 100%;
    overflow: hidden;
    .main {
        width: 100%;
        .top {
            box-sizing: border-box;
            padding: 12px 0 6px 12px;
            height: 36px;
            .top-content {
                width: 48px;
                height: 18px;
            }
        }
        .division {
            width: 100%;
            height: 7px;
            box-sizing: border-box;
            padding: 6px 12px 0;
            .line {
                width: 100%;
                height: 1px;
                background-color: #f5f5f5;
            }
        }
    }
    .bottom {
        box-sizing: border-box;
        padding: 9px 12px 9px;
        height: 54px;
        .bottom-contents {
            height: 36px;
            display: flex;
            align-items: center;
            .checkbox {
                width: 18px;
                height: 18px;
                border-radius: 2px;
                margin-right: 12px;
            }
            .circle {
                width: 36px;
                height: 36px;
                border-radius: 50%;
                margin-right: 12px;
            }
            .content {
                height: 36px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                .content-top {
                    height: 18px;
                    width: 120px;
                }
                .content-bottom {
                    height: 12px;
                    width: 240px;
                }
            }
        }
    }
    .animation {
        background: linear-gradient(
            90deg,
            #f5f5f5 25%,
            #ffffff 37%,
            #f5f5f5 63%
        );
        background-size: 400% 100%;
        background-position: 100% 50%;
        border-radius: 2px;
        animation: skeleton-loading 1.1s ease infinite;
    }
    @keyframes skeleton-loading {
        0% {
            background-position: 100% 50%;
        }

        100% {
            background-position: 0 50%;
        }
    }
}
</style>
